import React, { useState } from 'react';
import { TickerTape } from './components/widgets/TickerTape';
import { Sidebar } from './components/shell/Sidebar';
import { TopBar } from './components/shell/TopBar';
import { TerminalPanel } from './components/TerminalPanel';
import { StatementSection } from './components/StatementSection';
import { MarketsSection } from './components/MarketsSection';
import { StrategyBreakdown } from './components/StrategyBreakdown';
import { PropFirmBanner } from './components/PropFirmBanner';
import { OfferSection } from './components/OfferSection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <div id="top" className="min-h-screen w-full bg-ink font-sans" data-id="element-0" data-mp="2wk9xqj754kyk">
      <TickerTape data-id="element-1" data-mp="2whxd1y9zzwht" />

      <div className="flex pt-[76px]" data-id="element-2" data-mp="28u5yeo0zj7dd">
        <Sidebar mobileOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-3" data-mp="28t4lee0esat0" />

        <div className="flex min-w-0 flex-1 flex-col" data-id="element-4" data-mp="23w4fq47h1a2f">
          <TopBar onOpenMenu={() => setMenuOpen(true)} data-id="element-5" data-mp="23t8h0dnsuhcx" />

          <main className="min-w-0" data-id="element-6" data-mp="3iiwfuqnezm4a">
            <TerminalPanel data-id="element-7" data-mp="3ihv0i9zd8dgr" />
            <StatementSection data-id="element-8" data-mp="3mlayb9n68jv1" />
            <MarketsSection data-id="element-9" data-mp="3mkhou0wtvg97" />
            <StrategyBreakdown data-id="element-10" data-mp="3mjpyp5m02aqb" />
            <PropFirmBanner data-id="element-11" data-mp="3rcj6k2crlz6m" />
            <OfferSection data-id="element-12" data-mp="3rdas0kcnegj6" />
          </main>

          <SiteFooter data-id="element-13" data-mp="3reltuemj9e7n" />
        </div>
      </div>
    </div>;
}